export default __webpack_public_path__ + "static/media/portrait.f1c56104.svg";